import Button from '../../../../components/buttons/Button';
import { useState } from 'react';
import classNames from 'classnames';
import styles from '../../../calendar/dev/shift-detail/Modal.module.css';
import { Form, FormState } from 'informed';
import Modal from 'react-modal';
import TyInput from '../../../../components/inputs/TyInput';
import Spinner from '../../../../components/Spinner';
import { PrimaryButton } from '@tymbe/ty-components/button';

interface ChangeIkMpsvOicProps {
  onSubmit: (values: StateModalData) => Promise<any>;
  children?: React.ReactNode;
}

interface StateModalData {
  mpsv_oic: string;
}

const ChangeIkMpsvOic = ({ onSubmit, children }: ChangeIkMpsvOicProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (values: StateModalData)=> {
    setBusy(true);
    await onSubmit(values);
    setBusy(false);
  }

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <PrimaryButton
        onClick={(e) => {
          setOpenModal(true);
        }}
        className="text-xs"
        loading={busy}
        disabled={busy}
      >
        {children}
      </PrimaryButton>
      <Modal
        isOpen={openModal}
        onRequestClose={() => setOpenModal(false)}
        shouldCloseOnOverlayClick
        className={classNames('bg-bg m-auto rounded-xl px-6 py-4 w-[1000px]')}
        overlayClassName={styles.overlay}
        ariaHideApp={false}
      >
        <Form
          onSubmit={(values: FormState<StateModalData>) => {
            submit(values.values);
            setOpenModal(false);
          }}
        >
          <TyInput name="mpsv_oic" label="MPSV IK / OIČ" className="w-full" />
          <div className="flex justify-end items-center mt-8 gap-2">
            <Button
              type="button"
              className="w-12 flex justify-center hover:bg-error-300"
              onClick={() => setOpenModal(false)}
            >
              Zavřít
            </Button>
            <Button
              type="submit"
              className="w-12 flex justify-center enabled:hover:bg-primary-300 disabled:cursor-not-allowed"
            >
              Uložit
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default ChangeIkMpsvOic;
